import { useState } from "react";

export const useBooleanState = (initial) => {
  const [is, setIs] = useState(initial);
  const on = () => setIs(true);
  const off = () => setIs(false);
  const toggle = () => setIs(!is);
  const set = setIs;
  return { is, on, off, toggle, set };
};
